import useNativeListener from './useNativeListener';

interface Props {
    callbackFn?: () => void;
    deps?: any[];
}

function useOpenBarcode({ callbackFn, deps }:Props) {
    useNativeListener('openBarcode', () => {
        callbackFn?.();
    }, deps);
}

export default useOpenBarcode;
